import { render } from "./index.vue?vue&type=template&id=f3501d3c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=f3501d3c&lang=scss&scoped=true"

import exportComponent from "/Users/mymac/Documents/Digitala/Pulih_Anita/frontend-pulih/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3501d3c"]])

export default __exports__